var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseRounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0004 19.5999C15.3023 19.5999 19.6004 15.3018 19.6004 9.9999C19.6004 4.69797 15.3023 0.399902 10.0004 0.399902C4.69846 0.399902 0.400391 4.69797 0.400391 9.9999C0.400391 15.3018 4.69846 19.5999 10.0004 19.5999ZM7.93679 6.66351C7.58532 6.31203 7.01547 6.31203 6.66399 6.66351C6.31252 7.01498 6.31252 7.58483 6.66399 7.9363L8.7276 9.9999L6.66399 12.0635C6.31252 12.415 6.31252 12.9848 6.66399 13.3363C7.01547 13.6878 7.58532 13.6878 7.93679 13.3363L10.0004 11.2727L12.064 13.3363C12.4155 13.6878 12.9853 13.6878 13.3368 13.3363C13.6883 12.9848 13.6883 12.415 13.3368 12.0635L11.2732 9.9999L13.3368 7.9363C13.6883 7.58483 13.6883 7.01498 13.3368 6.66351C12.9853 6.31203 12.4155 6.31203 12.064 6.66351L10.0004 8.72711L7.93679 6.66351Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRounded);
export default __webpack_public_path__ + "static/media/close_rounded.6b19d36cb4e8903207ea37c60491751f.svg";
export { ForwardRef as ReactComponent };